module.exports = {"411025100":"城关镇","411025101":"颍桥回族镇","411025102":"麦岭镇","411025103":"颍阳镇","411025104":"王洛镇","411025105":"紫云镇","411025106":"库庄镇","411025107":"十里铺镇","411025108":"山头店镇","411025200":"湛北乡","411025202":"茨沟乡","411025203":"丁营乡","411025204":"姜庄乡","411025205":"范湖乡","411025206":"双庙乡","411025207":"汾陈乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/411025.json
// module id = 1481
// module chunks = 0